import React from 'react';

import { 
    DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton
} from "components";

import { func_validation } from 'functions';
import { useControlChanger, useCompanyStatus } from "./hooks";

import ic_add_account from "assets/images/ic_add_account.svg";
import { MultiFilters } from 'components/filters/MultiFilters';

import 'assets/scss/distributorPortal/modules/companyOverview.scss';



export function CompanyOverviewPresentation(props) {
    const { 
        comID,
        email, 
        createdDate,
        packageList,
    } = props;

    let comID_validated = func_validation.isNotNullUndefined(comID)? comID: "";

    const [
        submitStatusButton,
        statusDropdown
    ] = useCompanyStatus(props);

    const {
        currentTab, setCurrentTab,

        columns, 

        tableData,
        getTableList,
        addControlModals,

        isTableLoading,
        isTableRefreshRequired,

        totalOutlets,
        totalLicenses,

        setModalVisibility,

        addControlButtonText, addControlButtonDisable,
        isCheckboxRequired, isCheckboxColumnFirst,
        getMenuItems,
    } = useControlChanger(props);

    return (
        <DashboardLayout 
            className={"distributorPortal-companyOverview"}

            isHeaderCloseIconVisible pageHeaderCloseIcon={"distributorPortal-companyOverview-closeIcon"}
            updateParentState_visiblity={props.setIsCompanyOverviewVisible}
            breadcrumb={(
                <div className={"distributorPortal-companyOverview-breadcrumbs"}>
                    <span className={"distributorPortal-companyOverview-breadcrumbs-previous"} onClick={() => {
                        if (props.setIsCompanyOverviewVisible)
                            props.setIsCompanyOverviewVisible(false)
                    }}>Home</span>
                    <span className={"distributorPortal-companyOverview-breadcrumbs-arrow"}>{'>'}</span>
                    <span className={"distributorPortal-companyOverview-breadcrumbs-current"}>Client Details</span>
                </div>
            )}

            isHeaderDetailsVisible
            headerDetailTitleClassName={"distributorPortal-companyOverview-pageHeader-title pageHeaderTitle"}
            headerDetailTitle={"COM " + comID_validated}
            headerDetailBodyClassName={"distributorPortal-companyOverview-pageHeaderActions d-flex justify-content-between align-items-center"}
            headerDetailBody={(
                <React.Fragment>
                    <div className="distributorPortal-companyOverview-pageHeaderActions-tabs">
                        <span className={"distributorPortal-companyOverview-pageHeaderActions-tabs-outlet " +
                                (func_validation.isStringEqual_caseInsensitive(currentTab, "Outlet")? "distributorPortal-companyOverview-pageHeaderActions-tabs-outlet_selected ":"")}
                            onClick={() => { setCurrentTab("Outlet"); }}
                        >
                            Outlet Controls {func_validation.isNumberValid(totalOutlets)? "( " + totalOutlets + " )":""}
                        </span>
                        <span className={"distributorPortal-companyOverview-pageHeaderActions-tabs-license " +
                                (func_validation.isStringEqual_caseInsensitive(currentTab, "License")? "distributorPortal-companyOverview-pageHeaderActions-tabs-license_selected ":"")}
                            onClick={() => { setCurrentTab("License"); }}
                        >
                            License Controls {func_validation.isNumberValid(totalLicenses)? "( " + totalLicenses + " )":""}
                        </span>
                    </div>

                    {submitStatusButton}
                </React.Fragment>
            )}

            bodyClassName={"distributorPortal-companyOverview-body d-flex"}
            body={(
                <React.Fragment>
                    {/* License Modals */}
                    {addControlModals}

                    <div className={"row"}>
                        {/* Table */}
                        <div className={"col-9"}>
                            <GeneralTable
                                className={"distributorPortal-companyOverview-body-table"}
                                columns={columns}
                                data={tableData}

                                getTableData={getTableList}

                                outerTableHeader={(props) => {
                                    const {
                                      selectedRows, filterOptions,
                                      setFilterOptions,
                                    } = props;

                                    return (
                                        <div className={"distributorPortal-companyOverview-bodyHeader-action d-flex justify-content-between flex-column flex-xl-row "}>
                                            <div className={"d-flex flex-wrap align-items-center"}>
                                                <MultiFilters
                                                    defaultFilterOption={{
                                                        label: "License Key", 
                                                        propertyName: "licenseKey",
                                                        placeholder: "License Key",
                                                        inputType: "search"
                                                    }}
                                                    filterOptions={[
                                                        {
                                                            label: "License Key", 
                                                            propertyName: "licenseKey",
                                                            placeholder: "License Key",
                                                            inputType: "search"
                                                        },
                                                        {
                                                            label: "Device Name", 
                                                            propertyName: "deviceName",
                                                            placeholder: "Device Name",
                                                            inputType: "search"
                                                        },
                                                        {
                                                            label: "License Type", 
                                                            propertyName: "packageid",
                                                            placeholder: "License Type",
                                                            options: packageList?.map(pkg => ({
                                                                label: pkg.packageName,
                                                                value: pkg.packageId
                                                            })) || [],
                                                            inputType: "dropdown"
                                                        },
                                                    ]}
                                                    dropdownPlaceholder={"Select Filter"}
                                                    onApplyFilter={(inputFilters) => {
                                                        // find matched tab
                                                        setFilterOptions(func_validation.isObjectEmpty(inputFilters)? {} : { ...filterOptions, ...inputFilters});
                                                    }}
                                                />
                                            </div>
                                            <div className={"distributorPortal-companyOverview-tableHeaderAction-addAccountWrapper d-flex mt-3 mt-xl-0"}>
                                                <Button
                                                    className={"distributorPortal-companyOverview-tableHeaderAction-addAccount tableHeaderButtonPadding d-flex align-items-center"}
                                                    handleOnClick={() => { setModalVisibility(true); }}
                                                    isDisabled={addControlButtonDisable}
                                                    isDecoration_primaryTransparent
                                                >
                                                    <React.Fragment>
                                                        <img
                                                            className={"distributorPortal-companyOverview-headerAddAccount-icon"}
                                                            src={ic_add_account}
                                                            alt={"Add Icon"}
                                                        />
                                                        <div className={"distributorPortal-companyOverview-headerAddAccount-label tableHeaderButtonText"}>
                                                            {addControlButtonText}
                                                        </div>
                                                    </React.Fragment>
                                                </Button>

                                                {func_validation.isFunction(getMenuItems) && (
                                                    <div className='ml-2'>
                                                        <SubmenuTooltip
                                                            buttonClassName={"distributorPortal-companyOverview-tableHeaderAction-moreActionsWrapper"}
                                                            menuItems={getMenuItems(selectedRows)}
                                                        >
                                                            <MoreButton
                                                                iconClassName={"distributorPortal-companyOverview-moreActionsWrapper-icon"}
                                                            />
                                                        </SubmenuTooltip>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                }}

                                isTableDataLoading={isTableLoading}

                                isUsingPagination
                                totalRecords={(func_validation.isStringEqual_caseInsensitive(currentTab, "Outlet"))? totalOutlets: totalLicenses}

                                isTableRefreshRequired={isTableRefreshRequired}
                                isColumnResizeable
                                isTableOddRowsDarken isAllColumnWidthEqual
                                isCheckboxRequired={isCheckboxRequired}
                                isCheckboxColumnFirst={isCheckboxColumnFirst}
                            />
                        </div>

                        {/* Company Details */}
                        <div className={"col-3"}>
                            <div className="distributorPortal-companyOverview-body-companyDetailsWrapper">
                                <div className="distributorPortal-companyOverview-body-companyDetails">
                                    {/* Status */}
                                    {statusDropdown}

                                    {/* Login ID */}
                                    <div className="distributorPortal-companyOverview-companyDetails-loginID">
                                        <div className={"distributorPortal-companyOverview-companyDetails-loginID-label"}>
                                            Login ID
                                        </div>
                                        <div className={"noWrap-text-ellipsis"}>
                                            {func_validation.isStringTrimNotEmpty(email)? email:"-"}
                                        </div>
                                    </div>

                                    {/* Joined Date */}
                                    <div className="distributorPortal-companyOverview-companyDetails-joinDate">
                                        <div className={"distributorPortal-companyOverview-companyDetails-joinDate-label"}>
                                            Joined Date
                                        </div>
                                        <div>
                                            {func_validation.isStringTrimNotEmpty(createdDate)? createdDate:"-"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </React.Fragment>
            )}
        />
    );
}